import axios from 'axios';
import * as Constants from "../constants";


class TileService {
    rotate(preview, filename, direction) {
        return axios.post(Constants.API_URL + 'v2/tile/rotate', {
                code: preview,
                name: filename,
                direction: direction
            }).then(response => {
                return response.data;
            });
    }
    delete(preview, filename) {
        return axios.post(Constants.API_URL + 'v2/tile/delete', {
                code: preview,
                name: filename,
            }).then(response => {
                return response.data;
            });
    }
}

export default new TileService();
